"use client";
import { cn } from "@/lib/utils";

export default function Section({
  id,
  wrapperClassName,
  className,
  children,
  as,
  ...props
}) {
  const Element = as || "section";
  return (
    <Element
      id={id}
      className={cn(wrapperClassName, "py-12 lg:py-24")}
      {...props}
    >
      <div className={cn("content", className)}>{children}</div>
    </Element>
  );
}
